// extracted by mini-css-extract-plugin
export default {"link_box":"ServiceLink_link_box__+BSsj"};